import { render, staticRenderFns } from "./MdtLightbox.vue?vue&type=template&id=c3b5746a"
import script from "./MdtLightbox.vue?vue&type=script&lang=js"
export * from "./MdtLightbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports